import { render, staticRenderFns } from "./course-security.vue?vue&type=template&id=c7f88a80&scoped=true&"
import script from "./course-security.vue?vue&type=script&lang=js&"
export * from "./course-security.vue?vue&type=script&lang=js&"
import style0 from "./course-security.vue?vue&type=style&index=0&id=c7f88a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f88a80",
  null
  
)

export default component.exports